export default "__VITE_ASSET__38cb1022__"